import { render } from "./WalletViewSubscribe.vue?vue&type=template&id=018981d3&scoped=true&ts=true"
import script from "./WalletViewSubscribe.vue?vue&type=script&lang=ts"
export * from "./WalletViewSubscribe.vue?vue&type=script&lang=ts"

import "./WalletViewSubscribe.vue?vue&type=style&index=0&id=018981d3&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018981d3"]])

export default __exports__